import axios from "axios";
import { API_URL } from "../../config";
import instance from "../api/api";
import instancePos from "../api/apiV2";
const getPMIXReport = async (
  pageNum,
  pageSize,
  restaurant_id,
  dateRange,
  report_type
) => {
  const payload = {
    page_index: pageNum - 1,
    page_size: pageSize,
    restaurant_id: restaurant_id,
    start_date: dateRange[0].startDate,
    end_date: dateRange[0].endDate,
    report_type: report_type,
  };

  const response = await instance.post(`/get-pmix-report`, payload);
  return response.data;
};

const getLabourReport = async (
  pageNum,
  pageSize,
  restaurant_id,
  dateRange,
  report_type
) => {
  const payload = {
    page_index: pageNum - 1,
    page_size: pageSize,
    restaurant_id: restaurant_id,
    start_date: dateRange[0].startDate,
    end_date: dateRange[0].endDate,
    report_type: report_type,
  };
  const response = await instance.post(`/get-labour-report`, payload);
  return response.data;
};

const getSalesReport = async (
  pageNum,
  pageSize,
  restaurant_id,
  dateRange,
  report_type
) => {
  const payload = {
    page_index: pageNum - 1,
    page_size: pageSize,
    restaurant_id: restaurant_id,
    start_date: dateRange[0].startDate,
    end_date: dateRange[0].endDate,
    report_type: report_type,
  };
  const response = await instance.post(`/get-sales-report`, payload);
  return response.data;
};

const getSalesReportV1 = async (
  pageNum,
  pageSize,
  restaurant_id,
  dateRange,
  report_type
) => {
  const payload = {
    page_index: pageNum - 1,
    page_size: pageSize,
    restaurant_id: restaurant_id,
    start_date: dateRange[0].startDate,
    end_date: dateRange[0].endDate,
    report_type: report_type,
  };
  const response = await instance.post(`/get-sales-report-v1`, payload);
  return response.data;
};

const getDiscountReport = async (
  pageNum,
  pageSize,
  restaurant_id,
  dateRange,
  report_type
) => {
  const payload = {
    page_index: pageNum - 1,
    page_size: pageSize,
    restaurant_id: restaurant_id,
    start_date: dateRange[0].startDate,
    end_date: dateRange[0].endDate,
    report_type: report_type,
  };

  const response = await instance.post(`/get-discount-report`, payload);
  return response.data;
};

const changePMIXCategory = async (pmix_id, category, subcategory) => {
  const payload = {
    pmix_id: pmix_id,
    category: category,
    subcategory: subcategory,
  };
  const response = await instance.post(`/change-pmix-category`, payload);
  return response.data;
};

const changeSalesCategory = async (category, id) => {
  const payload = {
    category: category,
    sales_id: id,
  };
  const response = await axios.post(
    `${API_URL}/change-sales-category`,
    payload
  );
  return response.data;
};

const changeLabourCategory = async (category, id) => {
  const payload = {
    category: category,
    labour_id: id,
  };
  const response = await axios.post(
    `${API_URL}/change-labour-category`,
    payload
  );
  return response.data;
};

const getReportDetails = async (report_id) => {
  const payload = {
    report_id: report_id,
  };
  const response = await instance.post(`/get-report-details`, payload);
  return response.data;
};

const getUploadInstructions = async (body) => {
  const response = await instancePos.post(
    `/get_upload_report_file_instruction`,
    body
  );
  return response.data;
};

const uploadReportFile = async (body) => {
  const response = await instancePos.post(`/upload_report_file`, body);
  return response.data;
};

const getScrapperProcesses = async (page_index, page_size, restaurant_id) => {
  const body = {
    page_index: page_index - 1,
    page_size: page_size,
    restaurant_id: restaurant_id,
  };
  const response = await instance.post(`/get-scrapper-processes`, body);
  return response.data;
};

const getAllLaborClasses = async (restaurant_id) => {
  const body = {
    restaurant_id: restaurant_id,
  };
  const response = await instancePos.post(`/all_labor_classes`, body);
  return response.data;
};

const updateRawLabor = async (labor_obj_id, labor_id) => {
  const body = {
    labor_obj_id: labor_obj_id,
    labor_id: labor_id,
  };
  const response = await instancePos.post(`/update_raw_labor`, body);
  return response.data;
};

const addNewLaborClass = async (body) => {
  const response = await instancePos.post(`/add_new_labor_class`, body);
  return response.data;
};
export const getUrlFromS3 = async (restaurant_id, report_date, report_type) => {
  try {
    const response = await instance.post("/get-file-url-from-s3-bucket", {
      restaurant_id,
      report_date,
      report_type,
    });
    return response?.data;
  } catch (error) {
    console.log(error);
  }
};

const updateLaborReport = async (data) => {
  try {
    const body = {
      data: data,
    };
    const response = await instance.post("/update-report-labor", body);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export {
  getPMIXReport,
  getLabourReport,
  getSalesReport,
  getDiscountReport,
  changePMIXCategory,
  changeLabourCategory,
  changeSalesCategory,
  getReportDetails,
  getUploadInstructions,
  uploadReportFile,
  getScrapperProcesses,
  getAllLaborClasses,
  updateRawLabor,
  addNewLaborClass,
  updateLaborReport,
  getSalesReportV1,
};
